module.exports = __webpack_public_path__ + "img/submit-inquiry.5d90e524.png";